import React, {useEffect} from "react";
import {useSelector} from "react-redux";

import {mb} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {IRPStore} from "../../../app/rp_reducer";
import {createOfferLink} from "../../../offer/helpers/create_offer_link";
import {hitGTMOfferSelectItem} from "../../../offer/tracking/ecommerce_events/offer/hit_gtm_offer_select_item";
import {hitGTMOfferViewItemList} from "../../../offer/tracking/ecommerce_events/offer/hit_gtm_offer_view_item_list";
import {useMyOffersContext} from "../../contexts/MyOffersContext";
import {FavouriteListWrapper} from "../FavouriteListWrapper";
import {FavouritesListItem} from "../FavouritesList/FavouritesListItem";

interface IProps {
    className?: string;
}

export const FavouriteOfferSection = (props: IProps) => {
    const favouriteOffers = useSelector((store: IRPStore) => store.myOffers.favourites.offers.list);
    const {removeButtonsDisabled} = useMyOffersContext();

    useEffect(() => {
        if (favouriteOffers.length > 0) {
            hitGTMOfferViewItemList({
                offers: favouriteOffers,
                ...gtmMeta
            });
        }
    }, [favouriteOffers.map((offer) => offer.id).join(",")]);

    const handleFavouriteItemClick = (offerId: number) => {
        const offer = favouriteOffers.find((offer) => offer.id === offerId);

        if (offer) {
            hitGTMOfferSelectItem({
                offer,
                ...gtmMeta
            });
        }
    };

    return (
        <div css={props.className}>
            <Text as="h3" variant="mini_header" css={mb(2)}>
                Inwestycje
            </Text>

            <div>
                <FavouriteListWrapper>
                    {favouriteOffers.map((offer) => (
                        <FavouritesListItem
                            key={offer.id}
                            id={offer.id}
                            itemUrl={createOfferLink(offer)}
                            disableRemoveButton={removeButtonsDisabled}
                            type="offer"
                            imageSrc={offer.main_image?.m_img_375x211}
                            header={offer.name}
                            address={`${offer.address}`}
                            rodoData={{
                                vendorName: offer.vendor.name,
                                personalDataProcessorName: offer.configuration.personal_data_processor_name ?? "",
                                personalDataProcessorUrl: offer.configuration.personal_data_processor_url ?? "",
                                privacyPolicyUrl: offer.configuration.privacy_policy_url ?? ""
                            }}
                            roomsData={{
                                propertiesForSale: offer.stats?.properties_count_for_sale,
                                roomsRange: offer.stats?.rooms
                            }}
                            onClick={handleFavouriteItemClick}
                        />
                    ))}
                </FavouriteListWrapper>
            </div>
        </div>
    );
};

const gtmMeta = {
    listId: "moja_lista",
    listName: "Moja lista - inwestycje"
};
import React, {useEffect} from "react";
import {useSelector} from "react-redux";

import {mb} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {IRPStore} from "../../../app/rp_reducer";
import {createOfferLink} from "../../../offer/helpers/create_offer_link";
import {hitGTMOfferSelectItem} from "../../../offer/tracking/ecommerce_events/offer/hit_gtm_offer_select_item";
import {hitGTMOfferViewItemList} from "../../../offer/tracking/ecommerce_events/offer/hit_gtm_offer_view_item_list";
import {useMyOffersContext} from "../../contexts/MyOffersContext";
import {FavouriteListWrapper} from "../FavouriteListWrapper";
import {FavouritesListItem} from "../FavouritesList/FavouritesListItem";

interface IProps {
    className?: string;
}

export const FavouriteOfferSection = (props: IProps) => {
    const favouriteOffers = useSelector((store: IRPStore) => store.myOffers.favourites.offers.list);
    const {removeButtonsDisabled} = useMyOffersContext();

    useEffect(() => {
        if (favouriteOffers.length > 0) {
            hitGTMOfferViewItemList({
                offers: favouriteOffers,
                ...gtmMeta
            });
        }
    }, [favouriteOffers.map((offer) => offer.id).join(",")]);

    const handleFavouriteItemClick = (offerId: number) => {
        const offer = favouriteOffers.find((offer) => offer.id === offerId);

        if (offer) {
            hitGTMOfferSelectItem({
                offer,
                ...gtmMeta
            });
        }
    };

    return (
        <div css={props.className}>
            <Text as="h3" variant="mini_header" css={mb(2)}>
                Inwestycje
            </Text>

            <div>
                <FavouriteListWrapper>
                    {favouriteOffers.map((offer) => (
                        <FavouritesListItem
                            key={offer.id}
                            id={offer.id}
                            itemUrl={createOfferLink(offer)}
                            disableRemoveButton={removeButtonsDisabled}
                            type="offer"
                            imageSrc={offer.main_image?.m_img_375x211}
                            header={offer.name}
                            address={`${offer.address}`}
                            rodoData={{
                                vendorName: offer.vendor.name,
                                personalDataProcessorName: offer.configuration.personal_data_processor_name ?? "",
                                personalDataProcessorUrl: offer.configuration.personal_data_processor_url ?? "",
                                privacyPolicyUrl: offer.configuration.privacy_policy_url ?? ""
                            }}
                            roomsData={{
                                propertiesForSale: offer.stats?.properties_count_for_sale,
                                roomsRange: offer.stats?.rooms
                            }}
                            onClick={handleFavouriteItemClick}
                        />
                    ))}
                </FavouriteListWrapper>
            </div>
        </div>
    );
};

const gtmMeta = {
    listId: "moja_lista",
    listName: "Moja lista - inwestycje"
};
